import { StatusChip } from '../../../common/components';
import { formatDateTime } from '../../../utils/formatUtils';
import { RETURN_STATUS_CONFIG } from '../constants/consumptionReturnTexts';

/**
 * Contenido de una celda del listado de devoluciones: estado con chip, fecha formateada o texto.
 * @param {Object} props
 * @param {string} props.columnKey Clave de la columna.
 * @param {Object} props.row Devolución.
 * @returns {JSX.Element|string}
 */
const ConsumptionReturnCellValue = ({ columnKey, row }) => {
  if (columnKey === 'status') {
    const config = RETURN_STATUS_CONFIG[row.status];
    return (
      <StatusChip label={config?.label || row.status} color={config?.color} size="small" />
    );
  }
  if (columnKey === 'created_at') return formatDateTime(row.created_at);
  return row[columnKey] ?? '';
};

export default ConsumptionReturnCellValue;
